/**
 * 콘텐츠 이용 기기 관리 관련 상수 (업무 #11104 / #12064)
 * - 서비스별로 등록 가능한 기기는 3대
 * - 초과 시 안내에서 해제할 기기를 고르면 교체(replace)로 한 번에 처리된다
 */

/** 서비스별 기본 등록 가능 기기 수 (서버 응답의 limit이 없을 때 fallback) */
export const DEFAULT_DEVICE_LIMIT = 3;

/**
 * 기기 판정 결과를 재사용할 최대 시간(ms)
 *
 * 뷰어가 "뷰어 오픈 시 1회"만 판정하는 것과 맞춰, 채팅도 대화 단위로 1회만 판정한다.
 * 이 값은 탭을 계속 띄워둔 채 한 대화를 오래 이어갈 때
 * 원격 해제가 영영 반영되지 않는 것을 막는 상한이다.
 *
 * 연속으로 주고받는 메시지를 한 번으로 묶는 것이 목적이므로
 * 대화 전체 길이가 아니라 메시지 간격(길어야 1~2분)만 넘으면 충분하다.
 * 이보다 늘려도 호출 절감은 미미하고 원격 해제 감지만 늦어진다.
 *
 * 0으로 두면 캐시가 꺼지고 매 전송마다 판정한다 (기획 확정 전 되돌리기용).
 */
export const DEVICE_CHECK_MAX_AGE_MS = 5 * 60 * 1000;

/** 고객센터(help) 기기 관리 경로 */
export const DEVICE_MANAGE_PATH = "/member/device";

/**
 * 기기 관리 페이지 전체 URL
 * 도메인은 환경설정(REACT_APP_DEVICE_MANAGE_URL)에서 개발계/운영계로 분기된다
 */
export const getDeviceManageUrl = () =>
  `${process.env.REACT_APP_DEVICE_MANAGE_URL || ""}${DEVICE_MANAGE_PATH}`;

/** 기기 등록 초과 안내 문구 */
export const DEVICE_LIMIT_MESSAGE = {
  // STEP 01 - 초과 안내 + 해제할 기기 선택
  SELECT_TITLE: "등록 가능한 기기 수를 넘었어요",
  getSelectDescription: (limit: number) =>
    `과학동아 AiR에 이미 ${limit}대가 등록되어 있어요.\n해제할 기기를 선택하면 이 기기가 등록되고 이어서 이용할 수 있어요.`,
  SELECT_CONFIRM_BUTTON: "해제하고 계속하기",
  MANAGE_LINK: "기기 관리에서 자세히 보기",
  // 서버가 기기 목록을 내려주지 않은 경우 (선택할 대상이 없어 마이페이지로 유도)
  SELECT_EMPTY_DESCRIPTION:
    "과학동아 AiR에 등록할 수 있는 기기 수를 넘었어요.\n기기 관리에서 기존 기기를 해제하면 이어서 이용할 수 있어요.",
  MOVE_BUTTON: "기기 관리로 이동",

  // STEP 03 - 해제 확인
  CONFIRM_TITLE: "등록을 해제할까요?",
  getConfirmDescription: (deviceName: string) =>
    `${deviceName} 등록을 해제할까요?\n해제하면 목록에서 사라져요. 이 기기에서 다시 이용하면 자동으로 다시 등록돼요.`,
  REVOKE_BUTTON: "해제하기",

  // 기기 관리 페이지를 다녀온 뒤 재시도
  WAITING_TITLE: "기기를 해제하셨나요?",
  WAITING_DESCRIPTION:
    "기기 관리에서 기존 기기를 해제한 뒤 아래 버튼을 눌러주세요.\n해제가 완료되면 이 기기가 등록되고 입력한 메시지가 이어서 전송돼요.",
  RETRY_BUTTON: "다시 시도",

  // 오류 안내 (기획 Case 5)
  REVOKE_FAILED: "해제하지 못했어요. 잠시 후 다시 시도해 주세요.",
  RETRY_FAILED:
    "아직 등록할 수 있는 자리가 없어요. 기기를 해제한 뒤 다시 시도해 주세요.",

  CANCEL_BUTTON: "취소",
  PROCESSING_BUTTON: "처리 중...",
} as const;
